import { ref as storageRef, uploadBytes, getDownloadURL, deleteObject } from 'firebase/storage';
import { ref as dbRef, set, remove } from 'firebase/database';
import { updateProfile } from 'firebase/auth';
import { storage, database, auth } from '../firebase';
import { compressImage } from './compressImage';

const profilePhotoPath = (uid) => `profilePhotos/${uid}.jpg`;

export async function uploadProfilePhoto(file, uid) {
  const blob = await compressImage(file);
  const fileRef = storageRef(storage, profilePhotoPath(uid));
  await uploadBytes(fileRef, blob, { contentType: 'image/jpeg' });
  const url = await getDownloadURL(fileRef);
  await set(dbRef(database, `users/${uid}/profilePhotoUrl`), url);

  const currentUser = auth.currentUser;
  if (currentUser?.uid === uid) {
    await updateProfile(currentUser, { photoURL: url });
  }
  return url;
}

export async function removeProfilePhoto(uid) {
  try {
    await deleteObject(storageRef(storage, profilePhotoPath(uid)));
  } catch (err) {
    if (err?.code !== 'storage/object-not-found') throw err;
  }
  await remove(dbRef(database, `users/${uid}/profilePhotoUrl`));
}

export function resolveProfilePhotoUrl({ profilePhotoUrl, photoURL } = {}) {
  return profilePhotoUrl || photoURL || null;
}
